import script from "./componentWithActions.vue?vue&type=script&lang=js"
export * from "./componentWithActions.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__